import { useEffect, useState } from 'react'
import { Navigate, Outlet, useParams } from 'react-router'
import { observer } from 'mobx-react-lite'
import { EnumSpinnerLoaderPosition, SpinnerLoader } from 'shared/ui'
import { logger } from 'shared/lib'
import { CampaignApi, type IResponseFullCampaign } from 'entities/Campaign'
import { CampaignsPageIDContext } from 'pages/campaigns/context/context_id'

export const CampaignIdLayout = observer(() => {
  const { id } = useParams()
  const [loading, setLoading] = useState(true)
  const [response, setResponse] = useState<IResponseFullCampaign | null>(null)
  useEffect(() => {
    if (id) {
      let alive = true
      const getCampaign = async () => {
        try {
          const { data } = await CampaignApi.getById(id)
          if (!alive) return
          setResponse({ ...data.data, steps: data.data.steps.sort((a, b) => a.order - b.order) })
        } catch (e) {
          logger.error(e)
        } finally {
          if (alive) setLoading(false)
        }
      }
      getCampaign()
      return () => {
        alive = false
        setResponse(null)
        setLoading(true)
      }
    }
  }, [id])
  if (loading) {
    return (
      <SpinnerLoader ariaLabel={'CampaignIdLayout'} position={EnumSpinnerLoaderPosition.Absolute} />
    )
  }
  if (response) {
    return (
      <CampaignsPageIDContext.Provider value={response}>
        <Outlet />
      </CampaignsPageIDContext.Provider>
    )
  }
  return <Navigate to={'/'} replace />
})
